import press from '@/store/modules/searchEnginePage'
import globalStore from '@/store'
import Vue from 'vue'

export const customSearchClient = {
  getSelectedPoolsIds () {
    return Object.keys(press.state.checkedPools).reduce((ids, id) => {
      return press.state.checkedPools[id] ? [ ...ids, parseInt(id) ] : ids
    }, [])
  },
  checkStatus (res) {
    if (res.ok) { // res.status >= 200 && res.status < 300
      return res
    } else if (res.status === 401) {
      // unauthorized
      Vue.prototype.$auth0.login()
    }
    // TODO: manage others errors
  },
  async search (requests) {
    const accessToken = localStorage.getItem('accessToken')
    const headers = { 'Content-Type': 'application/json' }
    if (Vue.prototype.$auth0.isAuthenticated() === false || accessToken === undefined) {
      // user must be logged to get access to this index
      if (globalStore.state.unloggedUserIndex.indexOf(requests[0].indexName) === -1) {
        Vue.prototype.$auth0.login()
      }
    } else {
      headers['Authorization'] = `Bearer ${accessToken}`
    }
    return fetch(process.env.VUE_APP_SEARCH_PROXY, {
      method: 'post',
      headers: headers,
      body: JSON.stringify(
        { selectedPoolIds: this.getSelectedPoolsIds(),
          request: requests })
    }).then(this.checkStatus).then(res => res.json())
  }
}
